import "../styles/Main.scss";
import '../styles/customToastStyle.scss';

import logo from "../assets/0_nobg.png";

import { Outlet, Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { toast } from "react-toastify";

import { useMisc } from "../contexts/MiscContext";
import { useAuth } from "../contexts/AuthContext";

import headshot from "../assets/headshot_gen_neutral.png"
import LiveSearch from "../components/LiveSearch";
import CLink from "../components/CLink";
import axios from "../scripts/axiosConfig";


type SearchItem = { 
    name: string,
    type: string,
    id: string,
    url: string,
}

export default function Main() {

    const navigate = useNavigate();
    const location = useLocation();
    const { currentUser, USER_PRESENT, signinwithpopup } = useAuth();
    const { theme, setTheme, navTitle } = useMisc();

    const inputRef = useRef<HTMLInputElement>();

    const [showNavBox, setShowNavBox] = useState<boolean>(false);
    const [searchBarWrapperLostFocus, setSearchBarWrapperLostFocus] = useState<boolean>(true);
    const [loadingSearchResults, setLoadingSearchResults] = useState<boolean>(false);

    // -----------------------
    const [results, setResults] = useState<SearchItem[]>([]);
    const [selectedSearchItem, setSelectedSearchItem] = useState<SearchItem>();

    type changeHandler = React.ChangeEventHandler<HTMLInputElement>;
    const handleChange: changeHandler = (e) => {
        console.log("%c handleChange called.", "color: orange")
        // handles input in searchbar. get text from event, use setResults to show the search results.
        setLoadingSearchResults(true);
        const { target } = e;
        console.log(`Target value: ${target.value.trim()}`)
        if (!target.value.trim()) {
            console.log("Search query is empty.");
            setLoadingSearchResults(false);
            setResults([]);
            return;
        };

        console.log(`%c Searching for ${target.value}`, "color: green")

        const query = target.value.trim().toLowerCase();
        const cachedResults = sessionStorage.getItem(query);

        if (cachedResults) {
            setResults(JSON.parse(cachedResults));
            setLoadingSearchResults(false);
            return;
        }

        axios.post(
            "/search",
            { query },
            { timeout: 10000, timeoutErrorMessage: "Server didn't respond. Please try again later." }
        )
        .then((res) => {
            setResults(res.data);
            sessionStorage.setItem(query, JSON.stringify(res.data));
            setLoadingSearchResults(false);
        })
        .catch((err) => {
            console.log(err);
            toast.error(err?.data?.message || err.message);
            setLoadingSearchResults(false);
        });

    };

    return (
        <>
            {/* <RandomBubbles /> */}
            <div className="navBar">
                <div className="navBarWrap">
                    <div className="leftMenu">
                        <div className="logosContainer">
                            <img
                                className="navIcon"
                                src={logo}
                                alt="logo"
                            />
                        </div>

                        <div className="menuLink hideOnMobile">
                            <Link className="noStyle" to="/">
                                Home
                            </Link>
                        </div>
                         <div className="menuLink hideOnMobile">
                            <Link className="noStyle" to="/explore">
                                Explore
                            </Link>
                        </div>
                        <div className="menuLink hideOnMobile">
                            <Link className="noStyle" to="/contests">
                                Contests
                            </Link>
                        </div>
                    </div>

                    <div className="rightMenu">
                        <div className="searchBarContainer hideOnMobile">
                            <div className="searchBarWrapper" onBlur={() => setSearchBarWrapperLostFocus(true)}>

                                <LiveSearch
                                    iRef={inputRef}
                                    results={results}
                                    loading={loadingSearchResults}
                                    onChange={handleChange}
                                    onSelect={(item: SearchItem) => {
                                        setSelectedSearchItem(item);
                                        if (inputRef.current) inputRef.current.value = item.name;
                                        navigate(`/${item.type}s/${item.url}`, { state: { from: location.pathname } });
                                    }}
                                />
                            </div>
                            
                        </div>
                        {
                            (USER_PRESENT()) ? 
                                <CLink to={"/profile"} className="menuLink hideOnMobile account">
                                    <img src={currentUser.photoURL || headshot} referrerPolicy="no-referrer" alt="user's profile image" />
                                </CLink>
                            :
                                <CLink className="registerButton hideOnMobile" to={"/login"}>Sign In</CLink> 
                        }
                       

                        <div className="iconAndGrid showOnMobile">
                            <div
                                className="dropdown"
                                onBlur={() => console.log("lose ir")}
                            >
                                <RxHamburgerMenu
                                    size={"25px"}
                                    id="hamburger"
                                    onClick={() => {
                                        setShowNavBox(
                                            (showNavBox) => !showNavBox
                                        );
                                    }}
                                    onFocus={() => {
                                        console.log("focused");
                                    }}
                                    onBlur={() => {
                                        console.log("blurred");
                                    }}
                                />
                                <div
                                    className={`dropdown-content ${
                                        showNavBox ? "show" : ""
                                    }`}
                                >
                                    <span>
                                        <Link to="/">Home</Link>
                                    </span>
                                    <span>
                                        <Link to="/explore">Explore</Link>
                                    </span>
                                    <span>
                                        <Link to="/contests">Contests</Link>
                                    </span>
                                    {/* <span>Contact</span> */}
                                    {/* <span>
                                         <input
                                            type="checkbox"
                                            class="toggle"
                                            title="change color theme"
                                            onClick={() => {
                                                if (theme === "light") {
                                                    document.body.classList.remove("light");
                                                    document.body.classList.add("dark");
                                                    setTheme("dark");
                                                } else {
                                                    document.body.classList.remove("dark");
                                                    document.body.classList.add("light");
                                                    setTheme("light");
                                                }
                                            }}
                                        />
                                    </span> */}
                                    {
                                        (USER_PRESENT()) ? 
                                            <span>
                                                <CLink className="accountField" to={"/profile"} >Account</CLink>
                                            </span>
                                        : 
                                            <span>
                                                <CLink className="registerButton" to={"/login"}>Sign In</CLink>
                                            </span>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <ToastContainer progressClassName="toastProgress" bodyClassName="toastBody" /> */}

            <div className="out" >
                <Outlet />
            </div>
        </>
    );
}
